module.exports = __webpack_public_path__ + "img/logo2.84eab7fd.png";